import { createFileRoute } from '@tanstack/react-router';
import { FormOptionsTab } from '@web/modules/forms/options/form-options-tab';

export const Route = createFileRoute('/_app/capture/forms/$formId/options')({
  component: FormOptionsTab,
});
